<template>
  <div class="brand">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon class="brandBreadcrumbs">
    <svg class="icon" aria-hidden="true" style="fill: #9C7AFB;">
        <use xlink:href="#icon-CC" class="icon-CC"></use>
      </svg>
      <div slot="icon">
      <a-image
           class="guideImageTop"
           :alt="$t('seller.sellerAccount.guideAlt')"
           :src="require('@/assets/images/img/wenhao.png')"
           
        />
      </div>
         
    </breadcrumbs>
    <div style="margin: 8px 0;">
  <artemisads-segmented
              class="segmented"
              v-model:value="activeTab"
              :options="authorizationSegmentOptions"
            />
    </div>
   
     <!-- <segmentedTabs
      v-model="activeTab"
      :items="programConfig"
      :disabled="load"
      @change="onTabChange"
    /> -->
  
    <!-- <artmisads-segmented-tabs
      v-model="activeTab"
      :items="programConfig"
      :disabled="load"
      @change="onTabChange"
    /> -->
  
    <div class="guideContent">
      <div class="titleStyle">
        <div>
          {{
            activeTab === '0'
              ? $t('seller.sellerAccount.guideTitleInviteSeller')
              : $t('seller.sellerAccount.guideTitleInviteBrand')
          }}
        </div>
        <!-- <div class="rightBtn">
          <span :class="['text',{'textOp': language === 'zh'}]" @click="changeLanguage('en')">EN</span>
          <span class="text">/</span>
          <span :class="['text',{'textOp': language === 'en'}]" @click="changeLanguage('zh')">中</span>
        </div> -->
      </div>
    
      <div class="steps-box" id="authorization-steps">
        <a-steps  direction="vertical">
          <a-step v-for="(item, index) in stepInfo" :key="item.id">
            <template #title>
              <div class="titleStyle">{{ item.title }}</div>
            </template>
            <template #description>
              <div :class="`${item.defineOptionsClass} descriptionStyle`">
                <a-image
                  v-if="item.image"
                  class="guideImage"
                  :src="item.image"
                  :alt="$t('seller.sellerAccount.guideAlt')"
                  :preview="true"
                />
              </div>
              
            </template>
          </a-step>
        </a-steps>
      </div>
    </div>
    <authorizationModal ref="authorizationModalRef" @submit="submit" @clickGuide="clickGuide"/>
  </div>
</template>
<script setup >import i18n from '~/i18n'

import breadcrumbs from '../breadcrumbs.vue'
import { sellerAccountApi } from '~/server'
import { ref, computed, reactive, watch, h } from 'vue'
import { useI18n } from 'vue-i18n'
import { message } from 'ant-design-vue'
import authorizationModal from './components/authorizationModal.vue'

const { t, locale } = useI18n()
const load = ref(false)
const authorizationModalRef = ref(null)

const authorizationSegmentOptions = computed(() => [
  { label: t('seller.sellerAccount.tabAmazonSellerAccount'), value: '0' },
  { label: t('seller.sellerAccount.tabBrands'), value: '1' },
])

const getGuideSellerSteps = () => [
  {
    id: '0',
    title: t('seller.sellerAccount.guideSellerStep0'),
    defineOptionsClass: 'descriptionStyleOne',
    image: require('@/assets/images/img/step_one.jpg'),
  },
  {
    id: '1',
    title: t('seller.sellerAccount.guideSellerStep1'),
    defineOptionsClass: 'descriptionStyleTwo',
    image: require('@/assets/images/img/step_two.jpg'),
  },
  {
    id: '2',
    title: t('seller.sellerAccount.guideSellerStep2'),
    defineOptionsClass: 'descriptionStyleThree',
    image: require('@/assets/images/img/step_three.jpg'),
  },
  {
    id: '3',
    title: t('seller.sellerAccount.guideSellerStep3'),
    defineOptionsClass: 'descriptionStyleFour',
    image: require('@/assets/images/img/step_four.jpg'),
  },
]

const getGuideBrandSteps = () => [
  {
    id: '0_brand',
    title: t('seller.sellerAccount.guideBrandStep0'),
    defineOptionsClass: 'descriptionStyleOne',
    image: require('@/assets/images/img/step_one_brands.jpg'),
  },
  {
    id: '1_brand',
    title: t('seller.sellerAccount.guideBrandStep1'),
    defineOptionsClass: 'descriptionStyleTwo',
    image: require('@/assets/images/img/step_two_brands.jpg'),
  },
  {
    id: '2_brand',
    title: t('seller.sellerAccount.guideBrandStep2'),
    defineOptionsClass: 'descriptionStyleThree',
    image: require('@/assets/images/img/step_three_brands.jpg'),
  },
  {
    id: '3_brand',
    title: t('seller.sellerAccount.guideBrandStep3'),
    defineOptionsClass: 'descriptionStyleFour',
    image: require('@/assets/images/img/step_four_brands.jpg'),
  },
]

const stepInfo = ref(getGuideSellerSteps())
const dataSource = ref([])
const activeTab = ref('0')
const pagination = reactive({
  total: 0,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50'],
})

const breadcrumbsData = computed(() => ({
  title: t('seller.sellerAccount.breadcrumbAuthorization'),
  des: t('seller.sellerAccount.pageDesAuthorization'),
  hasTitleIcon: false,
  links: [
    { name: t('seller.common.home'), path: '/seller/dashboard' },
    {
      name: t('seller.menu.associateCentral'),
      path: '/seller/associateCentral/publishers',
    },
    {
      name: t('seller.sellerAccount.breadcrumbAuthorization'),
      path: '/seller/creatorConnections/authorization',
      icon: () =>
        h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
          h('use', { 'xlink:href': '#icon-CC' }),
        ]),
    },
    {
      name: t('seller.sellerAccount.breadcrumbGuide'),
      path: '/seller/sellerAccount/authorization/guide',
    },
  ],
}))

const syncSteps = () => {
  pagination.current = 1
  stepInfo.value =
    activeTab.value === '0' ? getGuideSellerSteps() : getGuideBrandSteps()
}

watch(activeTab, syncSteps, { immediate: true })
watch(locale, () => {
  stepInfo.value =
    activeTab.value === '0' ? getGuideSellerSteps() : getGuideBrandSteps()
})

const clickGuide = () => {}

const getAmazonSellerAccountList = async () => {
  load.value = true
  const res = await sellerAccountApi.getConnectionsList({
    page: pagination.current,
    size: pagination.size,
  })
  const { data, success, error } = res
  if (success) {
    dataSource.value = data.data
    pagination.total = data.total
  } else {
    message.error(error)
  }
  load.value = false
  // if(res.code==0){
  //   dataSource.value=res.data.connections
  //   pagination.total=res.data.total
  // }
}
const getBrandsList = async (id) => {
  load.value = true
  const res = await sellerAccountApi.getBrandsList({
    page: pagination.current,
    size: pagination.size,
    amazonUserId: id,
  })
  const { data, success, error } = res
  if (success) {
    dataSource.value = data.data
    pagination.total = data.total
  } else {
    message.error(error)
  }
  load.value = false
  // if(res.code==0){
  //   dataSource.value=res.data.connections
  //   pagination.total=res.data.total
  // }
}
const submit = () => {
      if (activeTab.value == '0') {
      sellerAccountApi
        .sellerAuthorization({
          id: record.id,
        })
        .then((res) => {
          if (res.success) {
            message.success(i18n.global.t('seller.msg.authorizationSuccess'))
            getAmazonSellerAccountList()
          } else {
            message.error(res.error)
          }
        })
    } else {
      sellerAccountApi
        .sellerBrandAuthorization({
          brandId: record.brandId,
        })
        .then((res) => {
          if (res.success) {
            message.success(i18n.global.t('seller.msg.authorizationSuccess'))
            getBrandsList()
          } else {
            message.error(res.error)
          }
        })
    }
}

// getAmazonSellerAccountList()
</script>
<style lang="less">
:where(.css-dev-only-do-not-override-wherky).ant-segmented .ant-segmented-group{
  padding: 3px;
}
.guideImageTop{
 margin-top: -8px;
}
.rightBtn{
  width: 66px;
height: 30px;
flex-shrink: 0;
border-radius: 112.05px;
background: #F2F1F6;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
.rightBtn{
  cursor: pointer;
}
.text{
color: #261e3e;
 text-align: center;
 font-family: "PingFang SC";
 font-size: 14px;
 font-style: normal;
 font-weight: 500;
 line-height: normal;
}
.textOp{
  opacity: 0.4;
}
}
#authorization-steps {
  .ant-steps {
  
      /* 完全禁止 a-steps 鼠标事件（移入/点击） */
  .steps-wrapper-steps {
   
  }
    .ant-steps-item {
        //  pointer-events: none !important;
        // cursor: default !important;
      .ant-steps-item-icon {
        background: #835cf2 !important;
        border: 1px solid #d9d9d9 !important;
        color: #fff !important;
        .ant-steps-icon {
          color: #ffffff !important;
        }
      }
      &.ant-steps-item-active {
        .ant-steps-item-title {
          font-weight: 550 !important;
          color: #835cf2 !important;
        }
        .ant-steps-item-description {
          color: #835cf2 !important;
        }
        .ant-steps-item-icon {
          background: #835cf2 !important;
          border-color: #835cf2 !important;
        }
      }
      &.ant-steps-item-process {
        .ant-steps-item-icon {
          background: #835cf2 !important;
          border-color: #835cf2 !important;
        }
      }
      &.ant-steps-item-finish {
        .ant-steps-item-icon {
          background: #835cf2 !important;
          border-color: #835cf2 !important;
          .anticon {
            color: #fff !important;
          }
        }
      }
    }
    .ant-steps-item-description {
      font-size: 12px !important;
      color: rgba(0, 0, 0, 0.45) !important;
    }
  }

}
.ant-steps-item-container {
  margin-top: 24px !important;
}
.artmisads-button.small{
  line-height: 15px !important;
}
.titleStyle {
  color: #1d2129;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'PingFang SC';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.descriptionStyle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  // overflow: hidden;

  .ant-image {
    max-width: 100% !important;
    max-height: 100% !important;
  }

  .guideImage {
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain;
  }
}

.descriptionStyleOne {
  width: 547px;
  // height: 179px;

  border-radius: 10px;
  background: #c4c4c4;
}

.descriptionStyleTwo {
    width: 547px;


  border-radius: 10px;
  background: #c4c4c4;
}

.descriptionStyleThree {
    width: 547px;

  border-radius: 10px;
  background: #c4c4c4;
}

.descriptionStyleFour {
    width: 716px;

  border-radius: 10px;
  background: #c4c4c4;
}

.descriptionStyleFive {
  width: 684px;
  height: 179px;

  border-radius: 10px;
  background: #c4c4c4;
}

.artmisads-segmented-tabs {
  margin-top: 0px !important;
}

.steps-box {
  margin-top: 30px;
}

.guideContent {
  border-radius: var(--Radius-Radius-10, 10px);
  padding: 20px 24px;
  border: 1px solid #fff;
  background: #fff;
  box-shadow: 0 1px 4px 0 #0000000a, 0 2px 16px 0 #00000014;

  .title {
    font-family: 'PingFang SC';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
  }
}

.guideContainer {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff5e4;
  padding: 8px 16px;
  border: 1px solid #ff9619;
  border-radius: 6px;
  position: absolute;
  right: 0;
  bottom: 20px;
  z-index: 1000;
  .wenhaoStyle {
    width: 26px !important;
    height: 26px !important;
  }

  .guideText {
    color: #0f0629b3;
    font-family: 'Sora';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }
}

.brand {
  padding: 16px;
  padding-top: unset;
}

.linkStyle {
  text-decoration: underline;
}
.brandBreadcrumbs{
  position: relative;
}
.table {
  padding: 16px !important;
  // margin: 0 16px;
  background-color: var(--color-white);
  border-radius: 8px;
  box-shadow: var(--section-box-shadow-6);
  // border: 2px solid #E8E5ED;
}
</style>
